export enum SortActionType {
  SET_SORT = 'SET_SORT',
}
